import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'leads-receptions-dashboard-received-leads',
  storeModule.createStoreModule('leads-receptions-dashboard-received-leads', {
    fetchListURL: 'leads-receptions/dashboard/received-leads'
  })
)
